import React, { useState, useEffect } from "react";
import style from "./ChildAlert.module.scss";
import Summary from "../Summary";
import PostList from "../PostList/PostList";
import { parseAlert } from "../../store/store";
import { PersonType } from "../../../AlertSimple/Fields/types";
import classNames from "classnames";

const ChildAlert = ({ childAlert, fetchs, dispatch }) => {
  const [loading, setLoading] = useState(true);

  close = () => {
    dispatch({ type: "TOGGLE_CHILD_ALERT" });
  };

  useEffect(() => {
    fetchs.alert({ id: childAlert.id }, (r, r2) => {
      dispatch({ type: "CHILD_ALERT_SUCCESS", alert: parseAlert(r.alertEvent) });
      setLoading(false);
    });
  }, [childAlert.id]);

  const getAllFiles = () => {
    if (childAlert.events == null) return [];
    let files = [];
    childAlert.events.forEach((e) => files.push(...e.files));
    return files;
  };

  return (
    <div className={style.child}>
      <button
        type="button"
        className={classNames("close", style.close)}
        aria-label="Close"
        onClick={() => close()}
      >
        <span aria-hidden="true">×</span>
      </button>

      <h6>Related alert</h6>
      <Summary
        loadingAlert={loading}
        title={childAlert.title}
        description={childAlert.description}
        personType={childAlert.personType}
        typeAlias={childAlert.personType == PersonType.All ? childAlert.accountId : childAlert.personId}
        relateds={null}
        files={getAllFiles()}
        fetchs={{
          downloadFile: fetchs.downloadFile,
        }}
      />

      <div className={style.posts}>
        <PostList loadingAlert={loading} events={childAlert.events} />
      </div>
    </div>
  );
};

export default ChildAlert;
